<template>
	<div class="bodyBgColor" id="monitorDetailPage">
		<div class="customer_header">
			<div @click="closeCurPage">关闭</div>
			<div>监控展示</div>
			<div class="headerMenu_c" @click="isMenuShow"></div>
			<div class="dropDownMenu" v-show="menuShow">
				<div class="menuArrow"></div>
				<div class="menuPanel">
					<div class="menuListO" @click="showAll">
						<div class="allImg menuListL"></div>
						<div class="menuListR" :class="{menuCur:menuCurAll}">全部</div>
					</div>
					<div class="menuListO" v-for="(item,index) in monitorList" @click="changeShow(index)">
						<div :class="item.monitorName|capitalize" class="menuListL"></div>
						<div class="menuListR" :class="{menuCur:index===selectedIndex}">{{item.monitorName}}</div>
					</div>
				</div>
			</div>
		</div>
		<div id="monitorDC">
			<div class="echartsPanel" v-for="(item,index) in monitorChartList" :class="[{echartShow:index===selectedIndex,isShow:isShow}]">
				<div class="echartTit" :class="item.status=='false'?'color1':'color2'">
					<div class="typeImg" :class="item.type|capitalize"></div><span class="chart-name">{{item.name}}</span><span v-show="isUnitShow=(item.unit!==undefined&&item.unit!=='')">({{item.unit}})</span>
				</div>
				<div class="echartBody">
					<wc-monitor-chart :id='"monitroChart_"+index' :monitorData=item></wc-monitor-chart>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	
	export default{
		name:'WcMonitorD',
		data(){
			return {
				selectedIndex:'',
				menuShow:false,
				isShow:false,
				menuCurAll:true,
				selectedId:0,
				monitorList:[
					/*{name:"内存利用率",type:'memory'},
					{name:"CPU利用率",type:'cpu'},
					{name:"风扇转速",type:'fan'},
					{name:"电源功率",type:'power'}*/
				],
				monitorChartList:[
					/*{
						name:"CPU利用率",
						type:'memory',
						status:1,
						unit:'%',
						dataTime:["11:11","11:12","11:13","11:14","11:15","11:16","11:17","11:18","11:19","11:20","11:21","11:22","11:23","11:24","11:25","11:26","11:27","11:28","11:29","11:30"],
						value:[2,5,4,4,8,9,7,12,16,15,25,12,14,12,10,9,8,6,7,19]
					},
					{
						name:"内存利用率",
						type:'cpu',
						status:1,
						unit:'%',
						dataTime:["11:11","11:12","11:13","11:14","11:15","11:16","11:17","11:18","11:19","11:20","11:21","11:22","11:23","11:24","11:25","11:26","11:27","11:28","11:29","11:30"],
						value:[12,15,14,14,18,9,7,2,6,15,25,12,4,12,10,19,18,16,17,20]
					},
					{
						name:"风扇转速",
						type:'fan',
						status:0,
						unit:'',
						dataTime:["11:11","11:12","11:13","11:14","11:15","11:16","11:17","11:18","11:19","11:20","11:21","11:22","11:23","11:24","11:25","11:26","11:27","11:28","11:29","11:30"],
						value:[12,5,4,4,8,9,7,12,26,15,25,2,14,12,10,19,18,6,17,17]
					},
					{
						name:"电源功率",
						type:'power',
						status:0,
						unit:'W',
						dataTime:["11:11","11:12","11:13","11:14","11:15","11:16","11:17","11:18","11:19","11:20","11:21","11:22","11:23","11:24","11:25","11:26","11:27","11:28","11:29","11:30"],
						value:[2,5,14,14,8,9,7,12,16,15,5,12,14,12,10,9,18,6,17,17]
					}*/
				]
			}
		},
		filters:{
			capitalize(value){
				let list=['memory','cpu','fan','power'];
				return (list.find(item=>{
					return value.toLowerCase().indexOf(item)>=0
				})||list[0])+'Img'
			}
		},
		methods:{
			isMenuShow(){
				this.menuShow=!this.menuShow;
			},
			changeShow(index){
				this.menuCurAll=false,
				this.menuShow=!this.menuShow;
				this.isShow=true;
				return this.selectedIndex=index;
			},
			calculateHeight(){
				//首先获取页面的高度
				var bodyHei = document.documentElement.clientHeight;
				//tabbar的高度为
				var tabbarHei = 40;
				//设置内容区的高度
				var minePage = document.getElementById("monitorDC");
				minePage.style.height = bodyHei-tabbarHei+"px";
			},
			showAll(){
				this.menuCurAll=true,
				this.menuShow=!this.menuShow;
				this.isShow=false;
				this.selectedIndex='';
			},
			closeCurPage(){
				let routeName=this.$route.name
				if(routeName=='monitorDetail'&&this.$route.query.s!=undefined){
					this.$router.push('/monitor?s='+this.$route.query.s+"&i="+this.$route.query.i)
				}else if(routeName=='monitorDetail'&&this.$route.query.str!=undefined){
					this.$router.push('/device?str='+this.$route.query.str)
				}else{
					window.history.length>1?this.$router.go(-1):this.$router.push('/');
				}
				
			},
			getAllSummary(){
				let routeName=this.$route.name
				if(routeName=='monitorDetail'&&this.$route.query.isDevice!=undefined){
					_api('_monitor','.code',{params:{mark:'monitorSummaryInfoByDeviceId',resource:this.$route.query.resource,monitorType:this.$route.query.type,selectedId:this.selectedId,
					deviceIp:this.$route.query.ip,isDevice:1}},res=>{
					this.monitorList=res.data;
					},err=>{
						
					})
				}else{
					_api('_monitor','.code',{params:{mark:'monitorSummaryInfoByDeviceId',resource:this.$route.query.resource,monitorType:this.$route.query.type,selectedId:this.selectedId,
					deviceIp:this.$route.query.ip}},res=>{
					this.monitorList=res.data;
					},err=>{
						
					})
				}
				
			},
			addExplain(itemName){
				var result;
				let powerPattern = /^电源((\d+\.)*\d+)状态/;
				let fanPattern = /^风扇((\d+\.)*\d+)状态/;
				let CPUPattern = /^CPU((\d+\.)*\d+)利用率/;
				let memPattern = /^内存((\d+\.)*\d+)利用率/;
				let temperaturePattern = /^((\d+\.)*\d+)温度/;
				if(powerPattern.test(itemName)){
					result = powerPattern.exec(itemName);
					if(itemName.indexOf("(")>0){
						itemName=itemName.substr(0,itemName.indexOf("("));
					}
				}
				else if(fanPattern.test(itemName)){
					result = fanPattern.exec(itemName);
					if(itemName.indexOf("(")>0){
						itemName=itemName.substr(0,itemName.indexOf("("));
					}
				}
				else if(CPUPattern.test(itemName)){
					result = CPUPattern.exec(itemName);
				}
				else if(memPattern.test(itemName)){
					result = memPattern.exec(itemName);
				}
				else if(temperaturePattern.test(itemName)){
					result = temperaturePattern.exec(itemName);
				}
				if(result!=undefined){
					return itemName + "(" + result[1] + "为监控项标识位)";		
				}else{
					//其他不变
					return itemName;
				}
			},
			getAllData(){
				let routeName=this.$route.name
				if(routeName=='monitorDetail'&&this.$route.query.isDevice!=undefined){
					_api('_monitor','.code',{params:{mark:'monitorDataByDeviceId',monitorType:this.$route.query.type,selectedId:this.selectedId,
					deviceIp:this.$route.query.ip,resource:this.$route.query.resource,isDevice:1}},res=>{
					console.error(11111,res);
					let list=['memory','cpu','fan','power'];
					let type=
					res.data.forEach(item=>{
						this.monitorChartList.push({name:this.addExplain(item.monitorName),type:list.find(type=>{return item.monitorName.toLowerCase().indexOf(type)>=0})||list[0],status:item.status,
								unit:'',dataTime:item.dateTime,value:item.dateValue})
					})
					},err=>{
						
					})
				}else{
					_api('_monitor','.code',{params:{mark:'monitorDataByDeviceId',monitorType:this.$route.query.type,selectedId:this.selectedId,
					deviceIp:this.$route.query.ip,resource:this.$route.query.resource}},res=>{
					console.error(11111,res);
					let list=['memory','cpu','fan','power'];
					let type=
					res.data.forEach(item=>{
						this.monitorChartList.push({name:this.addExplain(item.monitorName),type:list.find(type=>{return item.monitorName.toLowerCase().indexOf(type)>=0})||list[0],status:item.status,
								unit:'',dataTime:item.dateTime,value:item.dateValue})
					})
					},err=>{
						
					})
				}
				
			}
		},
		mounted() {
			this.calculateHeight();
			this.getAllSummary();
			this.getAllData();
		}
		
	}
</script>

<style scoped>
	.customer_header{
		background-image:linear-gradient(left,#00B5C0,#019BCD);
		background-image: -webkit-linear-gradient(left,#00B5C0,#019BCD);
	}
.chart-name{
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
	#monitorDC{
		overflow: auto;
		position: relative;
		top: 40px;
		padding-left: 5px;
		padding-right: 5px;
	}
	.allImg{
		background: url(../../../assets/images/allImg.png);
	}
	.memoryImg{
		background: url(../../../assets/images/memory.png);
	}
	.cpuImg{
		background: url(../../../assets/images/cpu.png);
	}
	.fanImg{
		background: url(../../../assets/images/fan.png);
	}
	.powerImg{
		background: url(../../../assets/images/power.png);
		
	}
	.menuListL{
		width: 16px;
		height: 16px;
		background-size:16px 16px ;
	}
	.echartTit{
		height: 30px;
		line-height: 30px;
		padding-left: 10px;
		padding-right: 10px;
		display: flex;
		align-items: center;
	}
	.echartsPanel{
		height: 200px;
		box-shadow: 2px 2px 10px #CECECE;
		margin-top: 10px;
		background: #FFFFFF;
	}
	.typeImg{
		margin-right: 8px;
		width: 14px;
		height: 14px;
		background-size:14px 14px ;
	}
	.echartBody{
		height: 170px;
	}
	.color1{
		color: red;
	}
	.color2{
		color: #008CC8;
	}
	.isShow{
		display: none;
	}
	.echartShow{
		display: block;
	}
	.chart-name{
        max-width : 350px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/detail/WcMonitorD.vue